import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import { useState, useEffect } from "react";
import React from "react";

import feather from "feather-icons";
import PropTypes from "prop-types";

export default function TableClient({
  data,
  columns,
  filtering,
  setFiltering,
  classNameTable,
  classNameTrHead,
  classNameTrBody
}) {
  const [sorting, setSorting] = useState([]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: { sorting, globalFilter: filtering },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  useEffect(() => {
    feather.replace();
  }, []);

  const pageIndex = table.getState().pagination.pageIndex; 
  const pageSize = table.getState().pagination.pageSize; 
  const totalRows = data.length; 
  const totalPages = table.getPageCount(); 

  const startItem = pageIndex * pageSize + 1;
  const endItem = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <>
      <table className={classNameTable}>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id} className={classNameTrHead}>
              {headerGroup.headers.map((header) => (
                <React.Fragment key={header.id}>
                  {header.column.columnDef.header}
                </React.Fragment>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="list">
          {table.getRowModel().rows.map((row) => (
            <tr
              key={row.id}
              className={classNameTrBody}
            >
              {row.getVisibleCells().map((cell) => (
                <React.Fragment key={cell.id}>
                  {cell.column.columnDef.cell
                    ? cell.column.columnDef.cell(cell) 
                    : cell.getValue()}
                </React.Fragment>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-4 mb-3 position-relative">
        <p className="mb-0 fs-9">
          <span className="d-none d-sm-inline-block">
            {startItem} a {endItem}
            <span className="text-body-tertiary"> Elementos de </span>
            {totalRows}
          </span>
        </p>

        <div className="d-flex position-absolute start-50 translate-middle-x">
          <button
            className="page-link btn btn-subtle-secondary me-1 mb-1"
            type="button"
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
          >
            <span className="fas fa-angle-double-left"></span>
          </button>
          <button
            className="page-link btn btn-subtle-primary me-1 mb-1"
            type="button"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            <span className="fas fa-chevron-left"></span>
          </button>
          <button
            className="page-link btn btn-subtle-primary me-1 mb-1"
            type="button"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            <span className="fas fa-chevron-right"></span>
          </button>
          <button
            className="page-link btn btn-subtle-secondary me-1 mb-1"
            type="button"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            <span className="fas fa-angle-double-right"></span>
          </button>
        </div>

        <p className="mb-0 fs-9">
          Pagina {pageIndex + 1} de {totalPages}
        </p>
      </div>
    </>
  );
}

TableClient.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  filtering: PropTypes.string,
  setFiltering: PropTypes.func,
  classNameTable: PropTypes.string,
  classNameTrHead: PropTypes.string,
  classNameTrBody: PropTypes.string
};
